import type { TTrajectory, TTrajectoryMeasure, TTrajectoryStation } from '../../types/trajectory';
import type { TFactTrajectory, TFactTrajectoryPoint } from '../model';

function measureValue(measure: TTrajectoryMeasure | undefined | null): number | null {
  if (!measure || typeof measure.value !== 'number' || Number.isNaN(measure.value)) {
    return null;
  }

  return measure.value;
}

function mapApiStationToFactPoint(station: TTrajectoryStation): TFactTrajectoryPoint {
  const projected = station.location?.[0]?.projected2dPosition;

  return {
    md: measureValue(station.md?.measuredDepth),
    inc: measureValue(station.incl),
    azMag: measureValue(station.computed?.aziMag) ?? measureValue(station.azi),
    azTrue: measureValue(station.computed?.aziTrue),
    tvd: measureValue(station.tvd?.verticalDepth),
    tvdss: measureValue(station.computed?.tvdss),
    ns: measureValue(station.dispNs),
    we: measureValue(station.dispEw),
    northing: typeof projected?.coordinate1 === 'number' ? projected.coordinate1 : null,
    easting: typeof projected?.coordinate2 === 'number' ? projected.coordinate2 : null,
    closure: measureValue(station.closure),
    vsec: measureValue(station.vertSect),
    ahd: measureValue(station.computed?.ahd),
    dls: measureValue(station.dls),
    tfo: measureValue(station.computed?.tfo),
  };
}

export function mapApiTrajectoryToFactTrajectory(raw: TTrajectory, wellId: number | null = null): TFactTrajectory {
  return {
    id: raw.id,
    title: raw.citation?.title ?? String(raw.id),
    wellId: wellId ?? 0,
    wellboreId: raw.wellboreId,
    points: (raw.trajectoryStations ?? []).map(mapApiStationToFactPoint),
  };
}
